import { RouteLocationRaw } from "vue-router"

import { Actions, Getters, store } from "@/store"

export default async (
  to,
  from,
  next: (arg?: RouteLocationRaw) => void
): Promise<void | boolean> => {
  await store.dispatch(Actions.RESET_SPRINT)
  const currentSprintId = store.getters[Getters.GET_CURRENT_SPRINT_ID]
  const projectId = store.getters[Getters.GET_CURRENT_PROJECT_ID]
  const teams = await store.dispatch(Actions.GET_TEAMS_IN_PROJECT, projectId)
  if (
    !currentSprintId &&
    teams &&
    teams.find(team => team.urlName === to.query.t && team.disableSprintCreation)
  ) {
    return teams.length === 1 ? next({ name: "Error", query: { code: 403 } }) : next({ query: {} })
  }
  if (!currentSprintId) {
    return next()
  }
  const currentSprint = await store.dispatch(Actions.GET_SPRINT, {
    sprintId: currentSprintId
  })
  // Check if the current sprint is neither started nor not started
  if (currentSprint?.id && !currentSprint.isStarted && !currentSprint.isNotStarted) {
    // Redirect to the SprintReview if the current sprint is completed or halted
    return next({
      name: "SprintReview",
      params: to.params
    })
  }
  return next()
}
